import { graphql } from 'gql';

export const uerExportWorkOrderChangeAsExcelGql = graphql(`
    query uerExportWorkOrderChangeAsExcel($workOrderChangeId: Long!) {
        uerExportWorkOrderChangeAsExcel(workOrderChangeId: $workOrderChangeId) {
            data {
                count
                dataUrl
                name
                size
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);
